import { EmptyFetchResponse } from '../connection.types';
import { Post } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const RevokeGreenroomInvitation = ({
  meeting,
  email,
  channel,
}: {
  meeting: number;
  email: string;
  channel: number;
}): Promise<EmptyFetchResponse> => {
  return Post({
    host: GREENROOM_HOST,
    path: '/v2/greenroom/revoke-invitation',
    body: {
      channel,
      meeting,
      email,
    },
    includeGreenroomToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default RevokeGreenroomInvitation;
